import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// third party
import moment from "moment";

// components
import HtmlPart from "../../parts/HtmlPart";
import TextCTA from "../../layout/buttons/TextCTA";
import CardTitlePart from "../../parts/CardTitlePart";
import Basket from "../../parts/Basket/";
import OverlayLoader from "../../parts/OverlayLoader";
import SuccessConfirmationOverlay from "../../parts/SuccessConfirmationOverlay";
import FailureOverlay from "../../parts/FailureOverlay";
import { config } from "../../config";

// actions
import {
  confirmOrder,
  canWeCancelOrder,
  cancelOrder,
} from "../../actions/orders";

const APP_INFO = config.APP_INFO;

class _OrderSummaryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      confirmed: false,
      cancelReasons: [
        "Delivery to home delay",
        "IFC decline or other issue",
        "Placed new dwell order",
        "No payment received",
        "No security details given",
        "Other",
        "Place order with another company",
        "Selected alternative dwell item",
        "Stock due in delay",
        "Suspected fraud",
        "System test - Do not use",
        "Unhappy with service",
        "Customer did not want",
      ],
      selectedCancelReason: "",
      order: props.order,
      cancellingOrder: false,
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
    this.cancelReasonChange = this.cancelReasonChange.bind(this);
    this.cancelOrder = this.cancelOrder.bind(this);
  }

  handleConfirm() {
    this.props.confirmOrder(
      this.props.id,
      this.props.orderRef,
      this.props.orderIdx
    );
    this.setState({
      confirmed: true,
    });
  }

  toggleExpand() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  cancelReasonChange(e) {
    this.setState({ selectedCancelReason: e.target.value });
  }

  cancelOrder() {
    this.props.cancelOrder(
      this.props.orderRef,
      this.props.orderNo,
      this.state.selectedCancelReason,
      this.props.total
    );
    this.setState({
      cancellingOrder: true,
    });
  }

  componentDidMount() {
    this.props.canWeCancelOrder(this.props.orderRef, this.props.orderNo);
  }

  getEstimatedDeliveryMessage(dateString, isChosenDeliveryDate) {
    let date = this.parseDateString(dateString);

    if (!date) {
      return null;
    }

    if (isChosenDeliveryDate) {
      return `Delivery date: ${date.format("DD/MM/YY")}*`;
    }

    let text =
      `<p>
        Great news! Your order is in progress. It's estimated to arrive in our delivery network on or around 
        <strong>${date ? date.format("DD/MM/YY") + "*" : "Unknown"}</strong>. 
        As soon as we have a confirmed date, you'll receive an email letting you know you can book your delivery. 
        <strong>Please don't arrange the disposal of your old sofa until your delivery has been booked.</strong>
      </p>`;

    return <HtmlPart htmlString={text} />;
  }

  getDeliveryDateMessage() {
    const { deliveryQuote } = this.props;

    if (!deliveryQuote && deliveryQuote === null) {
      return null;
    }

    if (APP_INFO.SHOW_ALT_DELIVEY_COVID_MESSAGE) {
      return null;
    }

    if (deliveryQuote.chosenDelivery && deliveryQuote.chosenDelivery.DeliveryDate) {
      return this.getEstimatedDeliveryMessage(deliveryQuote.chosenDelivery.DeliveryDate, true);
    }

    if (deliveryQuote.deliveryQuoteDays > 14 && deliveryQuote.efpDate) {
      if (deliveryQuote.deliveryQuoteDate && this.parseDateString(deliveryQuote.deliveryQuoteDate) > this.parseDateString(deliveryQuote.efpDate)) {
        return this.getEstimatedDeliveryMessage(deliveryQuote.deliveryQuoteDate, false);
      }

      return this.getEstimatedDeliveryMessage(deliveryQuote.efpDate, false);
    }

    if (deliveryQuote.deliveryQuoteDate) {
      return this.getEstimatedDeliveryMessage(deliveryQuote.deliveryQuoteDate, false);
    }

    return null;
  }

  parseDateString(dateString) {
    if (!dateString) {
      return null;
    }

    return moment(dateString.replace(/[^a-z0-9()]/gi, ""));
  }

  renderDeliveryDate() {
    let message = this.getDeliveryDateMessage();

    if (!message) {
      return null;
    }

    return (
      <div>
        <div className="u-padding-tiny u-text-center">
          <strong>Congratulations, your order is confirmed!</strong>
        </div>
        <div className="u-text-center">
          {message}
        </div>
        <div className="u-padding-tiny u-text-center c-event-feed__card__ts-and-cs">
          <small>
            *Please note - this is an estimate. Delivery dates are subject to
            change{" "}
          </small>
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.order.cancelled != null &&
      this.state.cancellingOrder === true
    ) {
      this.setState({
        cancellingOrder: false,
        order: { cancelled: this.props.order.cancelled },
      });
    }
  }

  render() {
    const {
      total,
      items,
      balance,
      deposit,
      orderRef,
      orderNo,
      title,
      bodyText,
      deliveryQuote,
      expandButtonText,
      hideButtonText,
      orderIdx,
      isILPOrder
    } = this.props;

    const { expanded } = this.state;

    const basketHeight = expanded ? "2000px" : "28vh";

    return (
      <div>
        <CardTitlePart title={title} />

        <div
          style={{ maxHeight: basketHeight, overflow: "hidden" }}
          className="basket-wrap u-padding-small u-pale-grey-bg"
        >
          {isILPOrder ? this.renderOrderApplication() : deliveryQuote && this.renderDeliveryDate()}

          <Basket
            items={items}
            total={total}
            deposit={deposit}
            balance={balance}
            orderIdx={orderIdx}
          />

          <div className="u-padding-tiny u-padding-top-small u-text-center c-event-feed__card__extra-info">
            <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
          </div>
        </div>

        <div className="u-clearfix c-event-feed__card__splitter u-flex-justify-end">
          <TextCTA
            text={expanded ? hideButtonText : expandButtonText}
            position={"right"}
            align={"right"}
            type={expanded ? "shrink" : "expand"}
            onBtnClick={this.toggleExpand}
          />
        </div>

        {!isILPOrder ?
          <div className="u-padding-small">
            {!this.props.order.cancelled ? (
              <HtmlPart htmlString={bodyText} />
            ) : (
              <HtmlPart htmlString={"Your order has been cancelled"} />
            )}
          </div>
          : null
        }
        {this.renderCancelOrder()}
      </div>
    );
  }

  renderOrderApplication() {
    const { ilpStatus, ilpSigningURL } = this.props;

    const isOrderAccepted = ilpStatus === 'ACCEPTED';
    const title = <strong className={isOrderAccepted ? "u-font-family-regular" : "u-font-family-medium"}>Your credit application is {isOrderAccepted ? ilpStatus.toLowerCase() : 'processing'}</strong>;

    const pendingMessage = `<p>We’ve got your sofa order and your credit application is in progress - please keep an eye out for your credit
                            agreement email, as you’ll need to e-sign this as soon as possible so we can get to work on your new sofa!</p>`;
    let acceptedMessage = `<p>Your credit application has been approved! Click below to e-sign your application so we can start work on your sofa.</p>
                           <a href="${ilpSigningURL}" className="c-range-display__colors" target="_blank">Click here to open e-sign page</a>`;

    const message = isOrderAccepted ? <HtmlPart htmlString={acceptedMessage} /> : <HtmlPart htmlString={pendingMessage} />;

    return (
      <div>
        <div className="u-padding-tiny u-text-center">
          <strong>{title}</strong>
        </div>
        <div className="u-text-center u-padding-bottom-tiny">
          {message}
        </div>
      </div>
    )
  }

  renderCancelOrder() {
    const { sofologist } = this.props;
    if (
      sofologist.Authorized &&
      this.props.order &&
      this.props.order.canWeCancel === true
    ) {
      return (
        <div className="u-padding-small">
          {!this.props.order.cancelled ? (
            <div className="form__group u-padding-tiny">
              <select
                aria-label="Reason for cancelling order"
                className="form__group__inputFields u-w-100"
                onChange={(e) => this.cancelReasonChange(e)}
                value={this.state.selectedCancelReason}
              >
                <option value={""}>Select reason to cancel</option>
                {this.state.cancelReasons.map((reason) => (
                  <option value={reason} key={reason}>
                    {reason}
                  </option>
                ))}
              </select>
              <OverlayLoader
                active={this.state.cancellingOrder === true}
                scale={0.5}
                background="rgb(255, 255, 255, 0.8)"
              />
              <button
                className="c-btn c-btn--cta u-margin-top-small"
                type="button"
                onClick={this.cancelOrder}
              >
                Cancel Order
              </button>
            </div>
          ) : null}
          <div className="form__group u-margin-top-tiny">
            {this.state.order && this.state.order.cancelled === true ? (
              <SuccessConfirmationOverlay />
            ) : null}
            {this.state.order && this.state.order.cancelled === false ? (
              <FailureOverlay />
            ) : null}
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  sofologist: state.sofologist,
  order: state.order,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      confirmOrder,
      cancelOrder,
      canWeCancelOrder,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(_OrderSummaryCard);



// WEBPACK FOOTER //
// ./src/cards/templates/OrderSummaryCard.js